// extracted by mini-css-extract-plugin
export default {"stepper-container":"Stepper_stepper-container__XHh+5","stepper-indicator":"Stepper_stepper-indicator__VZ4GU"};